<tt-compare-description
  [attr.data-testid]="'local-change-editor_chapter-description-' + widget().uniqueId"
  [id]="widget().uniqueId"
  [local]="widget().localChanges?.text"
  [mergeConflictStatus]="mergeConflictStatus()"
  [original]="widget().text"
  [references]="widget().references"
  [(compareMode)]="isCompareMode"
  [(editMode)]="isEditMode"
  (conflictResolved)="resolveMergeConflict.emit()"
  (conflictUnresolved)="unresolveMergeConflict.emit()"
  (localChanged)="handleLocalTextChanged($event)" />
